import { apiRequest } from './client'

// OPTIONS は Mock として呼ばれない(CORS のプリフライト処理が先に応答する)ため選べない
export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'HEAD'

export const HTTP_METHODS: HttpMethod[] = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD']

export interface RequestParamDoc {
  key: string
  example: string
  description?: string
}

export interface RequestErrorDoc {
  status: number
  description: string
}

export interface RequestDocs {
  headers: RequestParamDoc[]
  query: RequestParamDoc[]
  path_params: RequestParamDoc[]
  body_example: string | null
  body_description: string | null
  errors: RequestErrorDoc[]
}

export const EMPTY_REQUEST_DOCS: RequestDocs = {
  headers: [],
  query: [],
  path_params: [],
  body_example: null,
  body_description: null,
  errors: [],
}

export interface Endpoint {
  id: string
  project_id: string
  method: HttpMethod
  path: string
  priority: number
  description: string | null
  request_docs: RequestDocs
  created_at: string
  updated_at: string
}

export interface CreateEndpointInput {
  method: HttpMethod
  path: string
  priority?: number
  description?: string
  request_docs?: RequestDocs
}

export interface UpdateEndpointInput {
  method?: HttpMethod
  path?: string
  priority?: number
  description?: string | null
  request_docs?: RequestDocs
}

export async function listEndpoints(projectId: string): Promise<Endpoint[]> {
  return apiRequest<Endpoint[]>(`/api/projects/${projectId}/endpoints`)
}

export async function createEndpoint(projectId: string, input: CreateEndpointInput): Promise<Endpoint> {
  return apiRequest<Endpoint>(`/api/projects/${projectId}/endpoints`, {
    method: 'POST',
    body: input,
  })
}

export async function updateEndpoint(id: string, input: UpdateEndpointInput): Promise<Endpoint> {
  return apiRequest<Endpoint>(`/api/endpoints/${id}`, { method: 'PATCH', body: input })
}

export async function deleteEndpoint(id: string): Promise<void> {
  return apiRequest<void>(`/api/endpoints/${id}`, { method: 'DELETE' })
}
